export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '1.4.2',
    name: 'fpar2-clinic-locator-ui',
    versionDate: '2026-01-07T22:44:51.370Z',
};
export default versions;
